import { FormattedMessage } from 'react-intl';
import { NavItemType } from '../types/menu';
import { DeepReadonly } from '../types/DeepReadonly';
import { useMemo } from 'react';

export const useOrganizationMenuItems = (): DeepReadonly<NavItemType>[] =>
	useMemo(
		() => [
			{
				id: 'organization-settings',
				title: <FormattedMessage id={'menu.organization-settings'} />,
				type: 'item',
				url: '/settings/organization/settings',
				isActive: (location) => location.pathname.startsWith('/settings/organization/settings'),
			},
			{
				id: 'organization-resources',
				title: <FormattedMessage id={'menu.organization-resources'} />,
				type: 'item',
				url: '/settings/organization/resources/tags',
				isActive: (location) => location.pathname.startsWith('/settings/organization/resources/tags'),
			},
			{
				id: 'organization-members',
				title: <FormattedMessage id={'menu.organization-members'} />,
				type: 'item',
				url: '/settings/organization/members/members',
				isActive: (location) => location.pathname.startsWith('/settings/organization/members/members'),
			},
			{
				id: 'organization-billing',
				title: <FormattedMessage id={'menu.organization-billing'} />,
				type: 'item',
				url: '/settings/organization/billing',
				isActive: (location) => location.pathname.startsWith('/settings/organization/billing'),
			},
			{
				id: 'organization-security',
				title: <FormattedMessage id={'menu.organization-security'} />,
				type: 'item',
				url: '/settings/organization/security',
				isActive: (location) => location.pathname.startsWith('/settings/organization/security'),
			},
		],
		[],
	);
